import getServerSideData from "@/services/graph-ql/ssr";
import { createSlice } from "@reduxjs/toolkit";

export const dropdownOptions = createSlice({
  name: "dropdownOptions",
  initialState: {
    dropdownOptions: {},
  },

  reducers: {
    setLeadStatusesToState: (state, action) => {
      state.dropdownOptions.leadStatuses = action.payload;
    },
    setTaskStatusToState: (state, action) => {
      state.dropdownOptions.taskStatuses = action.payload;
    },
    setTaskTypeToState: (state, action) => {
      state.dropdownOptions.taskTypes = action.payload;
    },
    setTaskPriorityToState: (state, action) => {
      state.dropdownOptions.taskPriorities = action.payload;
    },
    setLanguagesToState: (state, action) => {
      state.dropdownOptions.languages = action.payload;
    },
    setLeadSourcesToState: (state, action) => {
      state.dropdownOptions.leadSources = action.payload;
    },
    setUsersToState: (state, action) => {
      state.dropdownOptions.users = action.payload;
    },
    setMembersToState: (state, action) => {
      state.dropdownOptions.members = action.payload;
    },
    //
    setLeadContactedUsersToState: (state, action) => {
      state.dropdownOptions.leadContactedUsers = action.payload;
    },
    setLeadOptionsToState: (state, action) => {
      state.dropdownOptions = { ...state.dropdownOptions, ...action.payload };
    },
    setDomainEmailsToState: (state, action) => {
      let options = action.payload;
      options = options.map((opt) => {
        opt.label = `${opt.alias} (${opt.label})`;
        return opt;
      });
      state.dropdownOptions.domainEmails = options;
    },
    setTagsToState: (state, action) => {
      state.dropdownOptions.tags = action.payload;
    },
    addNewTagToOptions: (state, action) => {
      state.dropdownOptions.tags = [
        ...state.dropdownOptions.tags,
        action.payload,
      ];
    },
    deleteTagFromOptions: (state, action) => {
      const { id } = action.payload;
      state.dropdownOptions.tags = state.dropdownOptions.tags.filter(
        (tag) => tag.id !== id
      );
    },
  },

  // extraReducers: (builder) => {
  //   // hydrate previous state while ssr
  //   builder
  //     .addCase(HYDRATE, (state, action) => {
  //       // Merge the hydrated state with the existing state
  //       if(typeof window !== 'undefined') {
  //         return {
  //           ...state,
  //           ...action.payload.dropdownOptions, // set server/client side states to avoid refetching
  //         };
  //       }
  //       return {
  //         ...state,
  //         dropdownOptions: {}
  //       }
  //     })
  //     // update state when createAsyncThunk return async data
  //     .addCase(getOptionsForCreateLead.fulfilled, (state, action) => {
  //       state.dropdownOptions = action.payload;
  //     })
  // },
});

export const {
  setLeadStatusesToState,
  setLanguagesToState,
  setLeadSourcesToState,
  setTagsToState,
  setUsersToState,
  setMembersToState,
  setLeadOptionsToState,
  setDomainEmailsToState,
  addNewTagToOptions,
  deleteTagFromOptions,
  setLeadContactedUsersToState,
  setTaskStatusToState,
  setTaskTypeToState,
  setTaskPriorityToState,
} = dropdownOptions.actions;

/**
 * These function called thunk and allows to perform async logic
 * It can be dispatched like a regular action: `dispatch(data)`
 **/
/** @name: @getOptionsForCreateLead
 *  @params: payload => query payload
 *  @description: Create an async thunk for fetching data
 */
export const getOptionsForCreateLead = (payload) => async (dispatch) => {
  const excludedRoles = ["SalesManagerReadonly"];
  const crmRoles = [
    "CRMAdmin",
    "CRMDefaultManager",
    "SalesManager",
    "SalesManagerReadonly",
  ];
  // let {
  //   dropdownOptions: { dropdownOptions }
  // } = getState();

  // // check if options data is already fetched or cached
  // if(Object.keys(dropdownOptions)?.length) {
  //   return dropdownOptions
  // }
  // get data from gql
  const data = await getServerSideData(payload);
  const options = JSON.parse(JSON.stringify(data));
  if (options?.leadStatuses?.length) {
    options.leadStatuses = options?.leadStatuses?.sort(
      (a, b) => a.sortOrder - b.sortOrder
    );
  }
  if (options?.users.length) {
    options.users = options.users.filter((x) => crmRoles.includes(x.role));
  }
  dispatch(setLeadOptionsToState(options));
  return options; // Return the data fetched from the server
};

export const getLeadStatuses = (state) => {
  return state.dropdownOptions.dropdownOptions?.leadStatuses;
};

export const getLanguages = (state) => {
  return state.dropdownOptions.dropdownOptions?.languages;
};

export const getLeadSources = (state) => {
  return state.dropdownOptions.dropdownOptions?.leadSources;
};

export const getUsers = (state) => {
  return state.dropdownOptions?.dropdownOptions?.users;
};
export const getSystemUsers = (state) => {
  return state.dropdownOptions?.dropdownOptions?.systemUsers;
};

export const getPreferredContact = (state) => {
  return state.dropdownOptions?.dropdownOptions?.preferredContact;
};
export const getTagColors = (state) => {
  return state.dropdownOptions?.dropdownOptions?.tagColors;
};
export const getBusinessCategories = (state) => {
  return state.dropdownOptions?.dropdownOptions?.businessCategory;
};

export const getDomainEmailState = (state) => {
  return state.dropdownOptions?.dropdownOptions?.domainEmails;
};
export const getWFTemplateCategories = (state) => {
  return state.dropdownOptions?.dropdownOptions?.wfTemplateCategories;
};
export const GetTaskStatuses = (state) => {
  return state.dropdownOptions?.dropdownOptions?.taskStatuses;
};
export const GetTaskTypes = (state) => {
  return state.dropdownOptions?.dropdownOptions?.taskTypes;
};
export const GetTaskPriorities = (state) => {
  return state.dropdownOptions?.dropdownOptions?.taskPriorities;
};

export const getDropdownOptions =
  (excludedRoles = []) =>
  (state) => {
    const { dropdownOptions } = state.dropdownOptions;
    const options = JSON.parse(JSON.stringify(dropdownOptions));
    if (options?.users?.length && excludedRoles?.length) {
      options.users = options?.users?.filter(
        (user) => !excludedRoles.includes(user.role)
      );
    }

    return options;
  };

export default dropdownOptions.reducer;
